module.exports = __webpack_public_path__ + "static/media/petdesk-phones-bi-logo.a59ad257.png";